import React, { useState, useEffect } from "react";
import { useStoreon } from "storeon/react";
import MainHeader from "../components/mainHeader/MainHeader";
import { useHistory } from "react-router-dom";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import {
  SAVE_GENERAL_SETTINGS,
  LOAD_GENERAL_SETTINGS,
} from "../../store/generalSettings";
import BackgroundColor from "../components/backgroungColor/backgroundColor";
import UploadImage from "../components/uploadImage/uploadImage";
import InputCheckboxWrapper from "../components/InputCheckboxWrapper/index";
import InputCheckboxReverse from "../components/InputCheckboxReverse/index";
import { useFormik } from "formik";
import img from "../../shared/images/settings-background.jpg";

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

export const GeneralSettingsForm = ({
  formik,
  onSelectBackground,
  initialImage,
  onChangeImage,
}) => (
  <div className={styles.bodyContainer}>
    <div className={styles.containerSettings}>
      <div className={styles.playerSettings}>
        <div className={styles.title}>Background Type</div>
        <div className={styles.bodySettings}>
          <InputCheckboxWrapper
            name="image"
            label="Background Image"
            checked={formik.values.background.type === "image"}
            onChange={() =>
              onSelectBackground(
                "image",
                formik.values.background.image || initialImage,
              )
            }
          >
            <UploadImage
              image={formik.values.background.image}
              uploadImage={onChangeImage}
            />
          </InputCheckboxWrapper>
          {!!formik.errors?.background?.image && (
            <span className={styles.error}>
              {formik.errors.background.image}
            </span>
          )}
          <InputCheckboxWrapper
            name="color"
            label="Background Color"
            checked={formik.values.background.type === "color"}
            onChange={() =>
              onSelectBackground(
                "color",
                formik.values.background.color || "#999",
              )
            }
          >
            <div style={{ marginRight: "10.28px" }}>
              <BackgroundColor
                handleChange={(color) => onSelectBackground("color", color.hex)}
                background={formik.values.background.color || "#999"}
                skew
              />
            </div>
          </InputCheckboxWrapper>
        </div>
      </div>
      <div className={styles.playerSettings}>
        <div className={styles.bodySettings}>
          <div className={styles.overallContainerPreview}>
            <MainHeader className={styles.topBarPreview} showMenu />
            <div
              className={styles.backgroundImagePreview}
              style={{
                background:
                  formik.values.background.type === "image"
                    ? `url(${formik.values.background.image}) no-repeat center center / cover`
                    : `${formik.values.background.color}`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
    <div className={styles.line} />
    <div
      className={styles.playerSettings}
      style={{
        width: "100%",
        paddingLeft: "54px",
        boxSizing: "border-box",
      }}
    >
      <div className={styles.title} style={{ margin: "53px 0 51px 0" }}>
        Manage Tables Visibility
      </div>
      <form className={styles.form}>
        <InputCheckboxReverse
          name="ten_frames_scorecard"
          onChange={formik.handleChange}
          value={formik.values.ten_frames_scorecard}
          checked={formik.values.ten_frames_scorecard}
        >
          <div
            className={styles.inputReverseLabelWrapper}
            style={{ height: "50px" }}
          >
            <span>10 Frames Scorecard</span>
            <span>Visible Only For Setup By Lane</span>
          </div>
        </InputCheckboxReverse>
        <InputCheckboxReverse
          name="compact_scorecard"
          onChange={formik.handleChange}
          value={formik.values.compact_scorecard}
          checked={formik.values.compact_scorecard}
        >
          <div
            className={styles.inputReverseLabelWrapper}
            style={{ height: "50px" }}
          >
            <span>Compact Scorecard</span>
            <span>Visible Only For Setup By Lane</span>
          </div>
        </InputCheckboxReverse>
        <InputCheckboxReverse
          name="list_players_top"
          onChange={formik.handleChange}
          value={formik.values.list_players_top}
          checked={formik.values.list_players_top}
        >
          <div
            className={styles.inputReverseLabelWrapper}
            style={{ height: "37px" }}
          >
            <span>List of Players with Top Frame</span>
          </div>
        </InputCheckboxReverse>
        <InputCheckboxReverse
          name="list_players_last_three"
          style={{ height: "37px" }}
          onChange={formik.handleChange}
          value={formik.values.list_players_last_three}
          checked={formik.values.list_players_last_three}
        >
          <div className={styles.inputReverseLabelWrapper}>
            <span>List of Players with Last 3 Frames</span>
          </div>
        </InputCheckboxReverse>
        <InputCheckboxReverse
          name="list_players_top_low"
          onChange={formik.handleChange}
          value={formik.values.list_players_top_low}
          checked={formik.values.list_players_top_low}
        >
          <div
            className={styles.inputReverseLabelWrapper}
            style={{ height: "37px" }}
          >
            <span>List of Players with Top and Low Frame</span>
          </div>
        </InputCheckboxReverse>
      </form>
    </div>
  </div>
);

const GeneralSettings = () => {
  const history = useHistory();
  const { dispatch, generalSettings, auth } = useStoreon(
    "generalSettings",
    "auth",
  );
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    dispatch(LOAD_GENERAL_SETTINGS, { history });
  }, [auth, dispatch]);

  useEffect(() => {
    formik.setValues({
      ten_frames_scorecard: generalSettings.ten_frames_scorecard,
      compact_scorecard: generalSettings.compact_scorecard,
      list_players_top: generalSettings.list_players_top,
      list_players_last_three: generalSettings.list_players_last_three,
      list_players_top_low: generalSettings.list_players_top_low,
      background: generalSettings.background || {
        type: "color",
        color: "#999",
      },
    });
  }, [generalSettings]);

  const formik = useFormik({
    initialValues: {
      ten_frames_scorecard: true,
      compact_scorecard: true,
      list_players_top: true,
      list_players_last_three: true,
      list_players_top_low: true,
      background: {
        type: "color",
        color: "#999",
      },
    },
    onSubmit: async ({ background, ...values }) => {
      const data = {
        settings: {
          background: {
            type: background.type,
            // send color field only if type is color
            ...(background.type === "color" ? { color: background.color } : {}),
          },
          ...values,
        },
      };

      try {
        dispatch(SAVE_GENERAL_SETTINGS, {
          image: background.type === "image" ? imageFile : null,
          data,
          history,
        });
      } catch (error) {
        console.log(error);
      }
    },
  });

  const onSelectBackground = (field, value = null) => {
    formik.setFieldValue("background.type", field);
    formik.setFieldValue(`background.${field}`, value);
  };

  const uploadImage = (image) => {
    if (image.size > 10000000) {
      formik.setFieldError(
        "background.image",
        "The uploaded image cannot exceed a size of 10M",
      );
      return;
    }

    setImageFile(image);
    getBase64(image).then((base64) => {
      onSelectBackground("image", base64);
    });
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.lines}></div>
      <GeneralSettingsForm
        formik={formik}
        onSelectBackground={onSelectBackground}
        initialImage={generalSettings.background.image}
        onChangeImage={uploadImage}
      />
      <div className={styles.bodyContainer}>
        <div style={{ paddingLeft: 54 }}>
          <button
            className={`${themeStyles.btnPrimaryLT} ${styles.submitButton}`}
            onClick={formik.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${img})`,
        }}
      />
    </div>
  );
};
export default GeneralSettings;
